import React, { useState, useEffect } from "react";
import AppLayoutWrapFull from "components/AppLayoutWrapFull";
import PageHeader from "components/PageHeader/PageHeader";
import Container from "components/Container/Container";
import PageHeaderActions from "components/PageHeader/components/PageHeaderActions/PageHeaderActions";
// import { setSelectedRows } from "helpers/utils";
import useFilterRows from "helpers/customHooks/useFilterRows";
import FullDataTable from "components/DataTable/FullDataTable";
import TableDefReports from "table-defs/TableDefReports";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { loadSitesAction, loadReportsAction, deleteReportAction, downloadReportAction } from "store/actions/Actions";
import AddReportModal from "./components/AddReportModal/AddReportModal";
import { toggleDropdowns } from "helpers/utils";

const reportsList = [
    {
        key: '1',
        name: "Gap Analysis",
        type: "gap"
    },
    {
        key: '2',
        name: "Remediation Plans",
        type: "remediation"
    },
    {
        key: '3',
        name: "Task Manager Report",
        isOrgWide: true,
        type: "task"
    },
    {
        key: '4',
        name: "Risk Analysis Summary",
        type: "risk"
    },
    {
        key: '5',
        name: "IT Device Audit Summary",
        type: "device"
    },
    {
        key: '6',
        name: "Affiliate Report",
        type: "vendor"
    },
    {
        key: '7',
        name: "Training and Attestation Report",
        type: "attestation"
    },
    {
        key: '8',
        name: "Incident Summary",
        type: "incident"
    },
];

const Reports = props => {
    const [state, setState] = useState({
        selectedRows: null,
        selected_sites: []
    });
    const [showModal, setShowModal] = useState(false);
    const { loadSitesAction, loadReportsAction, deleteReportAction, SitesReducer, ReportsReducer, downloadReportAction } = props;
    const noFilters = {
        text: "",
        type: "",
        "last-action": "",
        status: "",
        role: "",
        site: "",
        start: "",
        end: "",
        selected_sites: [],
        dateField: "date_from"
    };

    useEffect(() => {
        if (!SitesReducer.sites) {
            loadSitesAction();
        }
    }, [SitesReducer.sites, loadSitesAction]);

    useEffect(() => {
        if (!ReportsReducer.reports && SitesReducer.sites) {
            loadReportsAction();
        }
    }, [ReportsReducer.reports, SitesReducer.sites, loadReportsAction]);

    const [filters, setFilters] = useState(noFilters);
    const filteredRows = useFilterRows(filters, ReportsReducer.reports);

    // const setFilter = filterName => e => {
    //     setFilters({
    //         ...filters,
    //         [filterName]: e.target.type === "checkbox" ? e.target.checked : e.target.value || ((e.target && e.target.attributes && e.target.attributes.value && e.target.attributes.value.value) || '')
    //     });
    // };

    const onChangeRowSelect = ({ selectedRows }) => {
        if (selectedRows !== state.selectedRows) {
            setState(s => ({ ...s, selectedRows }));
        }
    };

    const setDateFilter = filterName => value => {
        setFilters({ ...filters, [filterName]: value });
    };

    const actDropdownRef = React.createRef();
    const siteDropdownRef = React.createRef();
    const chooseActionDropdownRef = React.createRef();
    const associatedSiteRef = React.createRef();

    // const [selectedReportIds, setSelectedReportIds] = useState([]);

    const handleDelete = (ids) => {
        deleteReportAction(ids);
    };

    const handleView = ({ hash, file_type = 'pdf'}) => {
        if (file_type && hash) {
            downloadReportAction({ file_type, hash });
        }
    };

    return (
        <AppLayoutWrapFull
            onClick={toggleDropdowns([
                associatedSiteRef,
                actDropdownRef,
                siteDropdownRef,
                chooseActionDropdownRef,
                // statusDropdownRef
            ])}        
        >
            <PageHeader showStats={true}>
                <PageHeaderActions
                    primaryButtonText="ADD REPORT"
                    primaryButtonHandler={() => setShowModal(!showModal)}
                    searchHandler={e =>
                        setFilters({ ...filters, text: e.target.value || "" })
                    }
                    searchValue={filters.text}
                    chooseAction={[
                        {
                            actionName: "Delete Selected",
                            actionHandler: () => handleDelete(state.selectedRows.map((item) => item.id))
                        }
                    ]}
                    chooseActionDropdownRef={chooseActionDropdownRef}
                    site={{
                        onClick: (e) => {
                            if (e.target.type === 'checkbox') {
                                let selected_sites = filters.selected_sites.slice();
                                if (e.target.checked) {
                                    selected_sites.push(e.target.value);
                                } else {
                                    selected_sites = selected_sites.filter(site => site !== e.target.value);
                                }
                                setFilters({
                                    ...filters,
                                    site: selected_sites.length > 0 ? `Sites (${selected_sites.length})` : 'Site',
                                    selected_sites: selected_sites
                                });
                            }
                        },
                        sites: SitesReducer.sites ? SitesReducer.sites.map(site => {
                            return {
                                id: site.id,
                                siteName: site.name,
                                value: filters.selected_sites.includes(site.id) ? true : false
                            }
                        }) : [],
                    }}
                    siteDropdownRef={siteDropdownRef}
                    dateRange={{
                        onChangeStart: setDateFilter("start"),
                        onChangeEnd: setDateFilter("end")
                    }}
                    filters={filters}
                    resetFilters={() => {
                        setFilters(noFilters);
                    }}
                />
            </PageHeader>
            <Container wide fluid>
                {ReportsReducer.reports &&
                <FullDataTable
                    rowsData={filteredRows}
                    definitions={TableDefReports}
                    onChangeRowSelect={({ selectedRows }) => onChangeRowSelect({ selectedRows })}
                    // setSelectedRows={setSelectedRows(["id"], setSelectedReportIds)}
                    customTableProps={{
                        selectedRows: state.selectedRows,
                        pdf: ({ hash }) => handleView({ hash, file_type: 'pdf' }),
                        csv: ({ hash }) => handleView({ hash, file_type: 'csv' }),
                        delete: ({ id }) => handleDelete([id])
                    }}
                />
                }
            </Container>

            {showModal ? (
                <AddReportModal
                    reportsList={reportsList}
                    setShowModal={setShowModal}
                    loadReportsAction={props.loadReportsAction}
                    // actDropdownRef={actDropdownRef}
                    // siteDropdownRef={siteDropdownRef}
                />
            ) : null}

        </AppLayoutWrapFull>
    );
};

const mapStateToProps = (state) => ({
    SitesReducer: state.SitesReducer,
    ReportsReducer: state.ReportsReducer
});

const mapDispatchToProps = {
    loadSitesAction,
    loadReportsAction,
    deleteReportAction,
    downloadReportAction,
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(Reports)
);
